import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../api/axiosInstance';

export const loginUser = createAsyncThunk(
    'auth/login',
    async (credentials, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post('/auth/login', credentials);
            localStorage.setItem('token', data.hal_token);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Login failed');
        }
    },
);

// SignUp User
export const signUpUser = createAsyncThunk(
    'auth/signup',
    async (credentials, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post('/auth/signup', credentials);
            localStorage.setItem('token', data.hal_token);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data.message || 'Signup failed');
        }
    },
);
// SignUp OTP Verification
export const signupOtpVerification = createAsyncThunk(
    'auth/verify-otp',
    async (credentials, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post('auth/verify-otp', credentials);
            localStorage.setItem('token', data.hal_token);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data.message || 'OTP Validation Failed');
        }
    },
);
// Delivery partner otp verification

export const signupOtpVerificationDeliveryPartner = createAsyncThunk(
    'auth/signupOtpVerificationDeliveryPartner',
    async (credentials, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post('auth/verify-otp', credentials);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data.message || 'OTP Validation Failed');
        }
    },
);
// Verify OTP
export const verifyOtp = createAsyncThunk(
    'auth/verify-otp',
    async (credentials, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post('auth/verify-otp', credentials);
            localStorage.setItem('token', data.hal_token);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data.message || 'OTP Validation Failed');
        }
    },
);
// Sent Login OTP
export const sentLoginOtpCode = createAsyncThunk(
    'auth/login-with-verify-otp',
    async (credentials, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post('auth/send-login-otp', credentials);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data.message || 'OTP Validation Failed');
        }
    },
);

// Login with OTP
export const loginWithOtpVerification = createAsyncThunk(
    'auth/login-with-otp',
    async (credentials, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post('auth/login-with-otp', credentials);
            localStorage.setItem('token', data.hal_token);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data.message || 'OTP Validation Failed');
        }
    },
);
// Reset Password OTP Validation

export const verifyOtpResetPasswordApi = createAsyncThunk(
    'auth/resetpassword-verify-otp',
    async (credentials, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post('auth/resetpassword-verify-otp', credentials);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data.message || 'OTP Validation Failed');
        }
    },
);
// Get User Profile
export const fetchUserProfile = createAsyncThunk(
    'auth/fetchUser',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get('/auth/me');
            return data;
        } catch (error) {
            return rejectWithValue('Failed to fetch user');
        }
    },
);

// Get User Payments
export const fetchUserPayments = createAsyncThunk(
    'auth/fetchUserPayments',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post('user/payments');
            return data?.data;
        } catch (error) {
            return rejectWithValue('Failed to fetch User Payments');
        }
    },
);

export const fetchCoreSettings = createAsyncThunk(
    'auth/fetchCoreSettings',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.get(`/core/settings`);
            return data;
        } catch (error) {
            return rejectWithValue('Failed to fetch core settings');
        }
    },
);

export const updateBillingAddress = createAsyncThunk(
    'auth/updateBillingAddress',
    async (payload, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(`/user/update-billing-address`, payload);
            return data;
        } catch (error) {
            return rejectWithValue('Failed to update user billing-address');
        }
    },
);

// Forget Password
export const forgetPassword = createAsyncThunk(
    'password-reset/forgot-password',
    async (credentials, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(
                'password-reset/forgot-password',
                credentials,
            );

            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data.message || 'OTP Validation Failed');
        }
    },
);

// Verify Reset Password Code
export const verifyResetCode = createAsyncThunk(
    'password-reset/verify-reset-code',
    async (credentials, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(
                'password-reset/verify-reset-code',
                credentials,
            );
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data.message || 'OTP Validation Failed');
        }
    },
);

// Update New Password
export const updateNewPassword = createAsyncThunk(
    'password-reset/reset-password',
    async (credentials, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post('password-reset/reset-password', credentials);
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data.message || 'OTP Validation Failed');
        }
    },
);
// Update a Delivery partner
export const deliveryPartnerSignup = createAsyncThunk(
    'auth/deliveryPartnerSignup',
    async (credentials, { rejectWithValue }) => {
        try {
            const { data } = await axiosInstance.post(
                '/delivery-partners/partner-signup',
                credentials,
            );
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data.message || 'Partner signup failed');
        }
    },
);


// Google OAuth Login
export const loginWithGoogle = createAsyncThunk(
    'auth/google-login',
    async (googleCredentials, { rejectWithValue }) => {
        try {
            // Split full name into firstname and lastname
            const nameParts = googleCredentials.name?.split(' ') || [];
            const firstname = nameParts[0] || '';
            const lastname = nameParts.slice(1).join(' ') || '';

            const { data } = await axiosInstance.post('/auth/social-login', {
                firstname: firstname,
                lastname: lastname,
                email: googleCredentials.email,
                phone_number: googleCredentials.phone_number || '',
                provider: 'google',
                provider_id: googleCredentials.provider_id,
                device_information: googleCredentials.device_information || '',
                referral_code: googleCredentials.referral_code || '',
            });

            // Token will be stored in authSlice reducer
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'Google login failed');
        }
    },
);

// Comprehensive logout thunk that clears all application data
export const performLogout = createAsyncThunk(
    'auth/performLogout',
    async (_, { dispatch, getState, rejectWithValue }) => {
        try {
            // Import actions dynamically to avoid circular imports
            const { logoutUser } = await import('../reducer/authSlice');
            const { clearLocalCart } = await import('../reducer/cartSlice');
            const { clearPartnerInfo } = await import('../reducer/deliveryPartnerSlice');
            const { resetAllOrders } = await import('../reducer/ordersSlice');

            // Import secure storage
            const { getSecureItem } = await import('../../utils/secureStorage');

            // Call server logout endpoint (but don't block on it)
            const token = getSecureItem('token');
            if (token) {
                try {
                    await axiosInstance.post('/auth/logout');
                } catch (error) {
                    // Server logout failed, but continue with client-side logout
                    console.warn('Server logout failed, continuing with client-side logout:', error);
                }
            }

            // Always clear everything regardless of server response
            dispatch(logoutUser());
            dispatch(clearLocalCart());
            dispatch(clearPartnerInfo());
            dispatch(resetAllOrders());
            localStorage.clear();
            sessionStorage.clear();
            return true;
        } catch (error) {
            console.error('Logout error:', error);
            // Even if there's an error, perform basic cleanup
            localStorage.clear();
            sessionStorage.clear();
            throw error;
        }
    }
);
